import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { IoMenu, IoClose } from "react-icons/io5";

// ลงทะเบียน Plugin
gsap.registerPlugin(ScrollTrigger);

const Navbar = () => {
  const navRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // 1. Animation ขาเข้าตอนโหลดหน้าเว็บ (Fade & Slide Down)
    gsap.fromTo(
      navRef.current,
      { opacity: 0, y: -20 },
      { opacity: 1, y: 0, duration: 1.2, ease: "power4.out", delay: 0.5 }
    );

    // 2. Smart Hide/Show Logic
    ScrollTrigger.create({
      start: "top -100", // เริ่มทำงานหลังจากเลื่อนลงมา 100px เพื่อไม่ให้เด้งตอนอยู่บนสุด
      onUpdate: (self) => {
        if (self.direction === 1) {
          // self.direction === 1 คือกำลังเลื่อนลง (Scroll Down) -> ซ่อน Navbar
          gsap.to(navRef.current, { 
            y: -120, 
            opacity: 0, 
            duration: 0.4, 
            ease: "power2.out" 
          });
        } else {
          // self.direction === -1 คือกำลังเลื่อนขึ้น (Scroll Up) -> โชว์ Navbar
          gsap.to(navRef.current, { 
            y: 0, 
            opacity: 1, 
            duration: 0.4, 
            ease: "power2.out" 
          });
        }
      }
    });
  }, []);

  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsOpen(false);
  };

  return (
    <nav
      ref={navRef}
      className="fixed top-6 left-1/2 -translate-x-1/2 z-[100] w-[90%] max-w-4xl transition-opacity duration-300"
    >
      <div className="bg-slate-900/60 backdrop-blur-xl border border-white/10 px-6 md:px-10 py-4 rounded-full flex justify-between items-center shadow-[0_20px_50px_rgba(0,0,0,0.3)]">
        
        {/* Logo */}
        <a 
          href="itsmejustin.space" 
          onClick={scrollToTop}
          className="text-white font-black italic text-xl tracking-tighter hover:scale-105 transition-transform"
        >
          JUSTIN<span className="text-yellow-500">.</span>
        </a>

        {/* Desktop Menu */}
        <div className="hidden md:flex items-center gap-10">
          {[
            { name: "About", id: "about" },
            { name: "Projects", id: "projects" },
            { name: "Contact", id: "contact" }
          ].map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={(e) => handleScroll(e, item.id)}
              className="relative text-xs font-black text-white/70 uppercase tracking-[0.2em] hover:text-yellow-500 transition-colors group"
            >
              {item.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-yellow-500 transition-all duration-300 group-hover:w-full"></span>
            </a>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white hover:text-yellow-500 transition-colors z-[110]"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <IoClose size={28} /> : <IoMenu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div
        className={`fixed top-[-24px] left-1/2 -translate-x-1/2 w-[105%] h-screen bg-[#0f172a]/95 backdrop-blur-2xl z-[105] flex flex-col justify-center items-center space-y-10 transition-all duration-500 
        ${isOpen ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"}`}
      >
        {[
          { name: "Home", id: "home", action: scrollToTop },
          { name: "About", id: "about", action: (e) => handleScroll(e, "about") },
          { name: "Projects", id: "projects", action: (e) => handleScroll(e, "projects") },
          { name: "Contact", id: "contact", action: (e) => handleScroll(e, "contact") }
        ].map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            onClick={item.action}
            className="text-4xl font-black text-white uppercase italic tracking-tighter hover:text-yellow-500 transition-all active:scale-90"
          >
            {item.name}
          </a>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;